import Constants from "expo-constants";

// load extra config from the app.json file
const extra = Constants.manifest?.extra ?? {};

const LOGIN_API = `${extra?.KEYCLOAK_URL}/auth/realms/${extra?.KEYCLOAK_REALM}/protocol/openid-connect/token`;
const USER_INFO_ENDPOINT = `${extra?.KEYCLOAK_URL}/auth/realms/${extra?.KEYCLOAK_REALM}/protocol/openid-connect/userinfo`;
const CHANGE_PASSWORD = `${extra?.KEYCLOAK_URL}/auth/realms/${extra?.KEYCLOAK_REALM}/account/#/security/signingin`;
// const URL = "https://coreeb-new.dev.pvcb.vn/api/eb/system/v2/user/transaction";
// const URL = "https://coreeb-new.dev.pvcb.vn/api/eb/system/v2/user";
const EKYC_URL = "https://onboarding.pvcombank.com.vn?rl=MB";

//URL test
// const URL = "http://10.1.134.64:8081/api/eb/system/v2/user";
// const URL = "http://app-nhdt-coreeb-coreeb-525eca1d5089dbdc-istio-system.apps.ocp4-dev01.pvcomtestocp.com/api/eb/system/v2/user";
// const URL = "https://eb.apps-ext.ocp4-dev03.pvcomtestocp.com:443/api/eb/system/v2/user";
// const URL = "https://app-nhdt-coreeb-coreeb-525eca1d5089dbdc-istio-system.apps.ocp4-dev01.pvcomtestocp.com:443/api/eb/system/v2/user";
const URL = `${extra.MB_API}/api/eb/system/v2/user`;
// const URL = "http://10.1.134.129:8081/api/eb/system/v2/user";
export default {
  url: URL,
  login: LOGIN_API,
  userInfoEndpoint: USER_INFO_ENDPOINT,
  changePassword: CHANGE_PASSWORD,
  ekycUrl: EKYC_URL,
  software_id: "PVCBMOBIBANK",
  software_version: "2.5.20210628",
  service_version: "2.5.20210628",
  private_key: "a1e3c21919adeeab",
  secret_key: "2fc30b63-7257-4b0b-a50c-082497d7b83b",
  extra,
  SALT: "jQOhAZdJbOLz6BPtBm1R",
};
